import script from "./VRSimulation.vue?vue&type=script&lang=ts&setup=true"
export * from "./VRSimulation.vue?vue&type=script&lang=ts&setup=true"

import "./VRSimulation.vue?vue&type=style&index=0&id=dc62140e&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc62140e"]])

export default __exports__